import { createApp } from 'vue'
import moment from 'moment'
import App from './App.vue'
import { registerPlugins } from './plugins'
import setupInterceptors from './plugins/setupInterceptors'
import 'moment/dist/locale/ru'

const app = createApp(App)

app.provide('baseUrl', import.meta.env.VITE_BASE_URL)

registerPlugins(app)

setupInterceptors()

moment.locale('ru')

app.mount('#app')
